import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import SocialLinks from './SocialLinks';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Routes>
            <Route path="/" element={<SocialLinks />} />
            {/* Добавь другие маршруты, если нужно */}
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;